module.exports = __webpack_public_path__ + "static/media/RAW.13d2d3c4.svg";